<template>
  <div class="module2Details detailsPage">
    <div class="optionArea u-cf">
      <div class="u-fl">
        <el-button type="primary" icon="el-icon-edit" @click.stop="onEdit">修改</el-button>
        <el-button @click.stop="onBack">返回</el-button>
      </div>
      <div class="u-fr">
      </div>
    </div>
    
    <div class="module2Details_con detailsPage_con u-border lable">
      <!--固定显示-->
      <el-row>
        <el-col :span="6">
          <p><span>xxx编码：</span>{{detailsData.code}}</p>
        </el-col>
        <el-col :span="6">
          <p><span>xxx名称：</span>{{detailsData.name}}</p>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
  // 接口
  import { testByGet } from '@/api/common';
  
  export default {
    name: 'module2Details',
    inject: ['myMessage'],
    data () {
      return {
        id: '',
        detailsData: {}
      };
    },
    methods: {
      requestDetails () {
        testByGet(this.id)
          .then(res => {
            this.handleDetailsData(res.data);
          })
          .catch(() => {
            this.myMessage.megError('获取详情信息失败');
          });
      },
      
      handleDetailsData (data) {
        this.detailsData = { ...data };
      },
      
      onEdit () {
        const paths = this.$route.path.split('/');
        paths.pop();
        this.$router.push({ path: paths.join('/') + '/new', query: { id: this.id } });
      },
      
      // 返回
      onBack () {
        const paths = this.$route.path.split('/');
        paths.pop();
        this.$router.push({ path: paths.join('/') });
      },
      
      // 页面初始化处理
      handlePageInit () {
        const paths = this.$route.path.split('/');
        const pathsLastParmas = paths[paths.length - 1];
        this.id = parseInt(pathsLastParmas);
        this.requestDetails();
      }
    },
    created () {
      this.handlePageInit();
    }
  };
</script>

<style lang="scss">
  .module2Details {
    .lable p > span:first-child {
      /*min-width: 110px;*/
    }
  }
</style>
